import React from 'react';
import { motion } from 'framer-motion';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
export function PrimaryButton({
  children,
  onClick,
  disabled = false,
  className = '',
  icon
}: PrimaryButtonProps) {
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.97
  }} onClick={onClick} disabled={disabled} className={`w-full min-h-[56px] rounded-lg font-bold text-lg flex items-center justify-center gap-2 transition-colors ${disabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-yellow-400 hover:bg-yellow-300 text-gray-900 shadow-lg shadow-yellow-400/20'} ${className}`} data-id="element-1881">
      {icon}
      {children}
    </motion.button>;
}